/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedProductOptimiserList } from '../models/PaginatedProductOptimiserList';
import type { PatchedProductOptimiser } from '../models/PatchedProductOptimiser';
import type { ProductOptimiser } from '../models/ProductOptimiser';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ProductsOptimisersService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedProductOptimiserList
     * @throws ApiError
     */
    public productsOptimisersList({
        page,
        pageSize,
        search,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedProductOptimiserList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-optimisers/',
            query: {
                'page': page,
                'page_size': pageSize,
                'search': search,
            },
        });
    }

    /**
     * @returns ProductOptimiser
     * @throws ApiError
     */
    public productsOptimisersCreate({
        requestBody,
    }: {
        requestBody: ProductOptimiser,
    }): CancelablePromise<ProductOptimiser> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/products-optimisers/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductOptimiser
     * @throws ApiError
     */
    public productsOptimisersRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this product optimiser.
         */
        id: number,
    }): CancelablePromise<ProductOptimiser> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-optimisers/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ProductOptimiser
     * @throws ApiError
     */
    public productsOptimisersUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product optimiser.
         */
        id: number,
        requestBody: ProductOptimiser,
    }): CancelablePromise<ProductOptimiser> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/products-optimisers/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductOptimiser
     * @throws ApiError
     */
    public productsOptimisersPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product optimiser.
         */
        id: number,
        requestBody?: PatchedProductOptimiser,
    }): CancelablePromise<ProductOptimiser> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/products-optimisers/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public productsOptimisersDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this product optimiser.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/products-optimisers/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
